// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import type { ClassContext, Message, Session, ThreadTask } from '@/types';
import { CACHE_TTL_MS } from '@/config/cacheConstants';

export const SESSIONS_CACHE_TTL_MS = CACHE_TTL_MS;

export interface PersistableChatStoreState {
  currentSession: Session | null;
  currentThreadId: string | null;
  currentThreadTasks: ThreadTask[];
  draftActorMode: 'teacher' | 'student';
  classContext: ClassContext | null;
  sessions: Session[];
  threadTasksByThread: Record<string, ThreadTask[]>;
  sessionsLoadedAt: number;
}

export function hasLikelyStaleSessionCache(
  session: Session | null,
  cachedMessages: Message[] | undefined,
  historyKnownMissing = false
): boolean {
  if (!session || !cachedMessages) {
    return false;
  }
  if (historyKnownMissing) {
    return false;
  }
  if (typeof session.message_count !== 'number') {
    return false;
  }
  if (cachedMessages.length === 0) {
    return session.message_count > 0;
  }
  if (session.message_count === 0) {
    return true;
  }
  return cachedMessages.every((message) => message.role === 'user');
}

export function buildChatStorePersistedSlice(state: PersistableChatStoreState) {
  return {
    currentSession: state.currentSession,
    currentThreadId: state.currentThreadId,
    currentThreadTasks: state.currentThreadTasks,
    draftActorMode: state.draftActorMode,
    classContext: state.classContext,
    sessions: state.sessions,
    threadTasksByThread: state.threadTasksByThread,
    sessionsLoadedAt: state.sessionsLoadedAt,
  };
}
